import { Color, Text, TextVariant } from '@billy/design-system'
import { Icon as LumenIcon } from '@shinetools/lumen-react'
import { ColorToken } from '@shinetools/lumen-tokens/web/colors'
import { Check } from 'lucide-react'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'
import { SimpleCheckListAlignment } from './types/SimpleCheckListAlignment'
import { SimpleCheckListVariant } from './types/SimpleCheckListVariant'

export interface TranslatedItem {
  isIncluded?: boolean
  tKey?: string
  text?: ReactNode
}

interface SimpleCheckListProps {
  alignment?: SimpleCheckListAlignment
  condensed?: boolean
  grid?: boolean
  iconColor?: ColorToken
  items: TranslatedItem[]
  showNotIncluded?: boolean
  textColor?: Color
  textVariant?: TextVariant
  variant?: SimpleCheckListVariant
}

export const SimpleCheckList = ({
  alignment = 'center',
  condensed,
  grid,
  items,
  iconColor,
  textColor,
  textVariant,
  variant = 'default',
}: SimpleCheckListProps) => {
  const { t } = useTranslation()

  return (
    <Styled.SimpleChecklistWrapper grid={grid} alignment={alignment}>
      {items
        .filter((item) => item.isIncluded !== false)
        .map((item, index) => (
          <Styled.ListItem key={item.tKey ?? index} condensed={condensed}>
            {variant === 'flat' ? (
              <Styled.FlatListIcon>
                <LumenIcon color={iconColor} icon={Check} size="small" />
              </Styled.FlatListIcon>
            ) : (
              <Styled.ListIcon icon="check" color={Color.White} />
            )}
            <Text
              alignment="left"
              color={textColor}
              variant={textVariant}
              weight={variant === 'flat' ? 'medium' : undefined}
            >
              {item.text ?? t(item.tKey ?? '')}
            </Text>
          </Styled.ListItem>
        ))}
    </Styled.SimpleChecklistWrapper>
  )
}
